<template>
  <div
    class="p-4 bg-black text-white h-screen w-full overflow-y-auto font-mono"
  >
    <h2 class="text-lg mb-2 text-white">Shipment logs</h2>
    <div v-for="(log, index) in logs" :key="index" class="mb-1 text-white">
      {{ log }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const logs = computed(() => {
  return store.getters["creditLine/getShipmentLogs"];
});
</script>

<style scoped>
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #4ade80;
  border-radius: 3px;
}
</style>
